<template>
  <div>
    <el-card style="margin: auto">
      <div slot="header" class="clearfix">
        <span style="float: left; font-weight: 800">kubernetes 集群列表</span>
        <el-button
          style="float: right"
          size="small"
          type="text"
          @click="show_add"
          >添加新集群</el-button
        >
      </div>

      <el-dialog
        :visible.sync="visible"
        title="添加 kubernetes 集群"
        width="30%"
      >
        <el-form ref="cluster" :model="cluster" :rules="rules">
          <el-form-item prop="name" label="集群名称">
            <el-input v-model="cluster.name" placeholder="请输入名称" />
          </el-form-item>
          <el-form-item prop="endpoint" label="Eedpoint">
            <el-input
              v-model="cluster.endpoint"
              placeholder="请输入 endpoint 地址"
            />
          </el-form-item>
          <el-form-item label="kubeconfig">
            <el-input
              v-model="cluster.kubeConfig"
              type="textarea"
              :rows="15"
              autosize
              :clearable="true"
            />
          </el-form-item>
          <el-form-item label="ca file">
            <el-input
              v-model="cluster.caFile"
              type="textarea"
              :rows="5"
              autosize
              clearable
            />
          </el-form-item>
          <el-form-item label="ca key">
            <el-input
              v-model="cluster.caKey"
              type="textarea"
              :rows="5"
              autosize
              clearable
            />
          </el-form-item>
          <el-form-item label="描述">
            <el-input
              v-model="cluster.description"
              type="textarea"
              :rows="5"
              autosize
              clearable
            />
          </el-form-item>
        </el-form>
        <template slot="footer">
          <el-button size="small" @click="visible = false">取消</el-button>
          <el-button size="small" type="primary" @click="create_cluster"
            >添加</el-button
          >
        </template>
      </el-dialog>

      <el-table :data="clusters" border>
        <el-table-column label="名称">
          <template slot-scope="record">
            <el-tag size="small" @click="manager(record.row.id)">{{record.row.name}}</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="endpoint 地址"
          prop="endpoint"
        ></el-table-column>
        <el-table-column label="描述" prop="description"></el-table-column>
        <el-table-column label="创建时间" prop="create_at"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="record">
            <el-button
              size="mini"
              type="info"
              @click="will_generate(record.row.id)"
              >生成kubeconfig</el-button
            >
            <el-button
              size="mini"
              type="primary"
              @click="get_cluster(record.row.id)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="delete_cluster(record.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <el-dialog
        :visible.sync="generate"
        title="生成kubeconfig配置"
        width="30%"
      >
        <el-form ref="bind" :model="bind" label-width="80px">
          <el-form-item prop="username" label="用户名">
            <el-select
              :value="bind.username"
              placeholder="选择角色"
              style="display: block"
              @change="change_user"
            >
              <el-option
                v-for="i in users"
                :key="i.name"
                :label="i.name"
                :value="i.name"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="clustername" label="集群名称">
            <el-input v-model="bind.clustername" disabled></el-input>
          </el-form-item>
        </el-form>
        <template slot="footer">
          <el-button size="small" @click="generate = false">取消</el-button>
          <el-button size="small" type="primary" @click="generate_kubeconfig">生成</el-button>
        </template>
      </el-dialog>

      <el-dialog :visible.sync="edit_visible" title="编辑集群配置" width="30%">
        <el-form ref="cluster" :model="cluster" :rules="rules">
          <el-form-item prop="name" label="集群名称">
            <el-input v-model="cluster.name" placeholder="请输入名称" />
          </el-form-item>
          <el-form-item prop="endpoint" label="Eedpoint">
            <el-input
              v-model="cluster.endpoint"
              placeholder="请输入 endpoint 地址"
            />
          </el-form-item>
          <el-form-item label="kubeconfig">
            <el-input
              v-model="cluster.kubeConfig"
              type="textarea"
              :rows="15"
              autosize
              :clearable="true"
            />
          </el-form-item>
          <el-form-item label="ca file">
            <el-input
              v-model="cluster.caFile"
              type="textarea"
              :rows="5"
              autosize
              clearable
            />
          </el-form-item>
          <el-form-item label="ca key">
            <el-input
              v-model="cluster.caKey"
              type="textarea"
              :rows="5"
              autosize
              clearable
            />
          </el-form-item>
          <el-form-item label="描述">
            <el-input
              v-model="cluster.description"
              type="textarea"
              :rows="5"
              autosize
              clearable
            />
          </el-form-item>
        </el-form>
        <template slot="footer">
          <el-button size="small" @click="visible = false">取消</el-button>
          <el-button size="small" type="primary" @click="update_cluster"
            >修改</el-button
          >
        </template>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      edit_visible: false,
      generate: false,
      users: [],
      cluster: {
        name: "",
        endpoint: "",
        kubeConfig: "",
        caFile: "",
        caKey: "",
        description: "",
      },
      bind: {
        username: "",
        clustername: "",
      },
      clusters: [],
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        endpoint: [
          { required: true, message: "请输入 endpoint 地址", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.get_clusters();
  },
  methods: {
    get_clusters() {
      const _this = this;
      _this.$axios
        .get(_this.config.path + "/k8sclusters?currentPage=0&pageSize=20", {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              showClose: true,
              type: "error",
              message: "获取集群列表失败: " + res.data.message,
            });
          } else {
            _this.clusters = res.data.data;
          }
        })
        .catch(function (err) {
          _this.$message({
            showClose: true,
            type: "error",
            message: "获取集群列表失败: " + err.toString(),
          });
        });
    },
    show_add() {
      this.cluster = {
        name: "",
        endpoint: "",
        kubeConfig: "",
        caFile: "",
        caKey: "",
        description: "",
      };
      this.visible = true;
    },
    create_cluster() {
      const _this = this;
      console.log("create new cluster: ", _this.cluster);
      _this.$axios
        .post(_this.config.path + "/k8sclusters", _this.cluster, {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              showClose: true,
              type: "error",
              message: "添加集群失败: " + res.data.message,
            });
          } else {
            _this.$message({
              message: "添加集群成功",
              showClose: true,
              type: "success",
            });
            setTimeout(() => {
              _this.$router.go(0);
            }, 500);
          }
        })
        .catch(function (err) {
          _this.$message({
            message: "添加集群失败: " + err.toString(),
            showClose: true,
            type: "error",
          });
        });
    },
    will_generate(id) {
      this.generate = true;
      const _this = this;
      // 获取用户列表
      _this.$axios
        .get(_this.config.path + "/users?currentPage=0&pageSize=15", {
          headers: {
            Authorization: "Bearer " + this.config.getCookie(),
          },
        })
        .then(function (response) {
          if (response.data.success === false) {
            _this.$message({
              showClose: true,
              message: "获取用户数据失败: " + response.data.message,
              type: "error",
            });
          } else {
            _this.users = response.data.data;
          }
        })
        .catch(function (error) {
          _this.$message({
            showClose: true,
            message: "获取用户数据失败: " + error.toString(),
            type: "error",
          });
        });
      // 获取集群信息
      _this.$axios
        .get(_this.config.path + "/k8sclusters/" + id, {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              message: "获取集群信息失败: " + res.data.message,
              showClose: true,
              type: "error",
            });
          } else {
            _this.cluster = res.data.data;
            _this.bind.clustername = res.data.data.name;
          }
        })
        .catch(function (err) {
          _this.$message({
            message: "获取集群信息失败: " + err.toString(),
            showClose: true,
            type: "error",
          });
        });
    },
    generate_kubeconfig() {
      const _this = this;
      _this.$axios
        .post(_this.config.path + "/kubeconfigs", _this.bind, {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              message: "生成kubeconfig失败: " + res.data.message,
              showClose: true,
              type: "error",
            });
          } else {
            _this.$message({
            message: "文件下载链接：" + _this.config.domain + "/#/kubeconfig/" + res.data.data,
            showClose: true,
            type: "success",
          });
            _this.generate = false;
          }
        })
        .catch(function (err) {
          _this.$message({
            message: "生成kubeconfig失败: " + err.toString(),
            showClose: true,
            type: "error",
          });
        });
    },
    change_user(value) {
      this.bind.username = value;
    },
    manager(id) {
      this.$router.push({name: 'cluster_manager', params: {id: id}});
    },
    get_cluster(id) {
      this.edit_visible = true;
      const _this = this;
      _this.$axios
        .get(_this.config.path + "/k8sclusters/" + id, {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              message: "获取集群信息失败: " + res.data.message,
              showClose: true,
              type: "error",
            });
          } else {
            _this.cluster = res.data.data;
          }
        })
        .catch(function (err) {
          _this.$message({
            message: "获取集群信息失败: " + err.toString(),
            showClose: true,
            type: "error",
          });
        });
    },
    update_cluster() {
      const _this = this;
      _this.$axios
        .put(
          _this.config.path + "/k8sclusters/" + _this.cluster.id,
          _this.cluster,
          {
            headers: {
              Authorization: "Bearer " + _this.config.getCookie(),
            },
          }
        )
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              message: "修改集群信息失败: " + res.data.message,
              type: "error",
              showClose: true,
            });
          } else {
            _this.$message({
              message: "修改集群信息成功",
              showClose: true,
              type: "success",
            });
            setTimeout(() => {
              _this.$router.go(0);
            }, 500);
          }
        })
        .catch(function (err) {
          _this.$message({
            message: "修改集群信息失败: " + err.toString(),
            type: "error",
            showClose: true,
          });
        });
      _this.edit_visible = false;
    },
    delete_cluster(id) {
      this.$confirm("删除集群后无法还原，确认删除么？", "删除集群", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          const _this = this;
          _this.$axios
            .delete(_this.config.path + "/k8sclusters/" + id, {
              headers: {
                Authorization: "Bearer " + _this.config.getCookie(),
              },
            })
            .then(function (res) {
              if (res.data.success === false) {
                _this.$message({
                  message: "删除集群失败: " + res.data.message,
                  showClose: true,
                  type: "error",
                });
              } else {
                _this.$message({
                  message: "删除记录成功",
                  showClose: true,
                  type: "success",
                });
                setTimeout(() => {
                  _this.$router.go(0);
                }, 500);
              }
            })
            .catch(function (err) {
              _this.$message({
                message: "删除集群失败: " + err.toString(),
                showClose: true,
                type: "error",
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
};
</script>        